import { ThemeProvider } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import { createTheme } from '@mui/material/styles';

import { primaryTheme } from '../../utils/theme';
import { FORTA_BLUE, FORTA_GRAY2 } from '../../utils/colors';
import { getThemeColor } from '../../utils/common';
import { Themes } from '../../constants';
import SortImg from '../../assets/images/sort.svg';

const getFHSimpleTableTheme = (theme: Themes) =>
  createTheme({
    ...primaryTheme,
    components: {
      MuiPaper: {
        styleOverrides: {
          root: {
            boxShadow: 'none',
          },
        },
      },
      MuiTable: {
        styleOverrides: {
          root: {
            cursor: 'default',
            textAlign: 'left',
          },
        },
      },
      MuiTableRow: {
        styleOverrides: {
          root: {
            '&.MuiTableRow-hover': {
              '&:hover': {
                backgroundColor: getThemeColor(theme).light3,
                cursor: 'pointer',
              },
            },
          },
        },
      },
      MUIDataTableBodyRow: {
        styleOverrides: {
          root: {
            borderBottom: `2px solid ${FORTA_GRAY2}`,
          },
        },
      },
      MUIDataTableHeadCell: {
        styleOverrides: {
          root: {
            fontWeight: 'bold',
            color: getThemeColor(theme).primary,
          },
          contentWrapper: {
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            '::after': {
              content: `""`,
              backgroundImage: `url(${SortImg})`,
              backgroundRepeat: 'no-repeat',
              width: '1.2em',
              height: '1.2em',
              display: 'block',
              marginTop: '0.5em',
              marginRight: '4px',
            },
          },
          sortAction: {
            '& path': {
              color: FORTA_BLUE.primary,
            },
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          root: {
            textAlign: 'left',
            fontSize: '16px',
          },
        },
      },
      MuiTypography: {
        styleOverrides: {
          h6: {
            fontSize: '21px !important',
            fontWeight: '700 !important',
          },
        },
      },
    },
  });

interface FHSimpleTableProps {
  colorTheme?: Themes;
  coloredBackground?: boolean;
  title?: string;
  data: any;
  columnDefinitions: any[];
  columnOptions?: any;
  tableTheme?: any;
}

const FHSimpleTable = (props: FHSimpleTableProps) => {
  const {
    data,
    columnDefinitions,
    columnOptions,
    title = '',
    colorTheme = Themes.Primary,
    tableTheme = getFHSimpleTableTheme(colorTheme),
  } = props;
  return (
    <ThemeProvider theme={tableTheme}>
      <MUIDataTable title={title} data={data} columns={columnDefinitions} options={columnOptions} />
    </ThemeProvider>
  );
};

export default FHSimpleTable;
